import Button from '../../../components/base/Button';

interface VoxDayHeroSectionProps {
  onOpenModal?: () => void;
}

export default function VoxDayHeroSection({ onOpenModal }: VoxDayHeroSectionProps) {
  const handleCTAClick = () => {
    if (onOpenModal) {
      onOpenModal();
    }
  };

  return (
    <section className="relative text-white pt-24 pb-16 overflow-hidden">
      <div className="absolute inset-0 bg-[url('/images/voxday/fundo.jpeg')] bg-cover bg-center"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/40 via-gray-800/30 to-gray-900/40"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-block mb-6 px-4 py-2 bg-[#F19E1A] rounded-full">
            <span className="text-sm font-bold uppercase tracking-wide">VoxDay - Experiência Transformadora</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Em apenas <span className="text-[#F19E1A]">4 horas</span> você pode desbloquear uma habilidade que pode mudar sua vida inteira: 
            <span className="text-[#F19E1A]">a sua comunicação.</span>
          </h1>
          
          <div className="mb-12 space-y-6">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
              Participe do <strong className="text-white">VoxDay</strong>, uma experiência presencial da Vox2you criada para quem quer:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <i className="ri-check-line text-[#F19E1A] text-2xl"></i>
                <span className="text-lg font-semibold">falar com confiança</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <i className="ri-check-line text-[#F19E1A] text-2xl"></i>
                <span className="text-lg font-semibold">perder o medo de se expor</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <i className="ri-check-line text-[#F19E1A] text-2xl"></i>
                <span className="text-lg font-semibold">comunicar ideias com clareza</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <i className="ri-check-line text-[#F19E1A] text-2xl"></i>
                <span className="text-lg font-semibold">gerar impacto ao falar</span>
              </div>
            </div>
            
            <p className="text-lg text-gray-300 mt-6">
              Tudo isso na prática, em um ambiente profissional e transformador.
            </p>
          </div>
          
          <div className="flex flex-col items-center gap-4">
            <Button 
              size="lg" 
              onClick={handleCTAClick}
              className="text-lg px-10 py-4 shadow-2xl hover:shadow-[#F19E1A]/50 transform hover:scale-105 transition-all duration-300"
            >
              🎯 Quero Participar do VoxDay
            </Button>
            
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <i className="ri-alarm-warning-line text-[#F19E1A]"></i>
              <span className="font-semibold">Vagas limitadas</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
